module.exports = __webpack_public_path__ + "img/sym6.d46519b8.png";